import React from "react";
import "../Tablas premiaciones/premiaciones.css";

const GrupoDosTable = () => (
  <section>
    <h2>Grupo Dos - 40 KM</h2>
    <div className="tableContainerG2">
      <table className="race-tableG2">
        <thead>
          <tr>
            <th>Categoría</th>
            <th>Edad</th>
            <th>Clave</th>
            <th>1er Lugar</th>
            <th>2do Lugar</th>
            <th>3er Lugar</th>
            <th>4to Lugar</th>
            <th>5to Lugar</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Juvenil Libre Varonil</td>
            <td>18 años y menos</td>
            <td>J</td>
            <td>$1,000.00</td>
            <td>$800.00</td>
            <td>$600.00</td>
            <td>$400.00</td>
            <td>$300.00</td>
          </tr>
          <tr>
            <td>Juvenil Libre Femenil</td>
            <td>18 años y menos</td>
            <td>JF</td>
            <td>$1,000.00</td>
            <td>$800.00</td>
            <td>$600.00</td>
            <td>$400.00</td>
            <td>$300.00</td>
          </tr>
          <tr>
            <td>Master 20 Varonil</td>
            <td>19 a 29 años</td>
            <td>L</td>
            <td>$1,000.00</td>
            <td>$800.00</td>
            <td>$600.00</td>
            <td>$400.00</td>
            <td>$300.00</td>
          </tr>
          <tr>
            <td>Femenil 20</td>
            <td>19 a 29 años</td>
            <td>F</td>
            <td>$1,000.00</td>
            <td>$800.00</td>
            <td>$600.00</td>
            <td>$400.00</td>
            <td>$300.00</td>
          </tr>
          <tr>
            <td>Master 30 Varonil</td>
            <td>30 a 39 años</td>
            <td>NH</td>
            <td>$1,000.00</td>
            <td>$800.00</td>
            <td>$600.00</td>
            <td>$400.00</td>
            <td>$300.00</td>
          </tr>
          <tr>
            <td>Femenil 30</td>
            <td>30 a 39 años</td>
            <td>H</td>
            <td>$1,000.00</td>
            <td>$800.00</td>
            <td>$600.00</td>
            <td>$400.00</td>
            <td>$300.00</td>
          </tr>
          <tr>
            <td>Master 40 Varonil</td>
            <td>40 a 49 años</td>
            <td>WE</td>
            <td>$1,000.00</td>
            <td>$800.00</td>
            <td>$600.00</td>
            <td>$400.00</td>
            <td>$300.00</td>
          </tr>
          <tr>
            <td>Femenil 40</td>
            <td>40 a 49 años</td>
            <td>E</td>
            <td>$1,000.00</td>
            <td>$800.00</td>
            <td>$600.00</td>
            <td>$400.00</td>
            <td>$300.00</td>
          </tr>
          <tr>
            <td>Master 50 Varonil</td>
            <td>50 a 59 años</td>
            <td>ZQ</td>
            <td>$1,000.00</td>
            <td>$800.00</td>
            <td>$600.00</td>
            <td>$400.00</td>
            <td>$300.00</td>
          </tr>
          <tr>
            <td>Master 60 Varonil</td>
            <td>60 años y más</td>
            <td>D</td>
            <td>$1,000.00</td>
            <td>$800.00</td>
            <td>$600.00</td>
            <td>$400.00</td>
            <td>$300.00</td>
          </tr>
          <tr>
            <td>Femenil 50</td>
            <td>50 años y más</td>
            <td>Q</td>
            <td>$1,000.00</td>
            <td>$800.00</td>
            <td>$600.00</td>
            <td>$400.00</td>
            <td>$300.00</td>
          </tr>
          <tr>
            <td>Mamut's Varonil</td>
            <td>90 kg y más</td>
            <td>M</td>
            <td>$1,000.00</td>
            <td>$800.00</td>
            <td>$600.00</td>
            <td>$400.00</td>
            <td>$300.00</td>
          </tr>
          <tr>
            <td>E-BIKE FEMENIL</td>
            <td>Libre</td>
            <td>EF</td>
            <td>Medalla</td>
            <td>Medalla</td>
            <td>Medalla</td>
            <td>Medalla</td>
            <td>Medalla</td>
          </tr>
          <tr>
            <td>E-BIKE VARONIL</td>
            <td>Libre</td>
            <td>EB</td>
            <td>Medalla</td>
            <td>Medalla</td>
            <td>Medalla</td>
            <td>Medalla</td>
            <td>Medalla</td>
          </tr>
          <tr>
            <td>Rodadores Femenil</td>
            <td>Rodador</td>
            <td>G</td>
            <td>Medalla</td>
            <td>Medalla</td>
            <td>Medalla</td>
            <td>Medalla</td>
            <td>Medalla</td>
          </tr>
          <tr>
            <td>Rodadores Varonil</td>
            <td>Rodador</td>
            <td>R</td>
            <td>Medalla</td>
            <td>Medalla</td>
            <td>Medalla</td>
            <td>Medalla</td>
            <td>Medalla</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
);

export default GrupoDosTable;
